export default "__VITE_ASSET__383ef879__$_?nuxt_component=async__"